import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createMuiTheme, Fab, makeStyles, MuiThemeProvider, Paper, Tab, TableCell, Tabs, TextField, Typography, Badge } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from 'mui-datatables';
import AddIcon from '@material-ui/icons/Add';
import CloseImage from '../../assets/ic_delete.png';
import IconArrow from '../../assets/ic_arrow.png';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import api from '../api';
import { format } from 'date-fns';
import Loader from 'react-loader-spinner'
import { useHistory, useLocation } from 'react-router-dom';
import TabSubFacility from '../pemanggilan/tabSubfacility';
import { usePrevious } from '../../library/Util';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptionsNofilSearch()

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function PemanggilanRegistrasi(props) {
    let location = useLocation();
    let history = useHistory();
    const classes = useStyles()
    const [noAntri, setNoAntri] = React.useState("");
    const [namaPasien, setNamaPasien] = React.useState("")
    const [kodePesanan, setKodePesanan] = React.useState("")
    const [notes, setNotes] = React.useState("")
    const [newNotes, setNewNotes] = React.useState("")
    const [waktu, setWaktu] = React.useState(new Date())
    const [value, setValue] = React.useState(0);
    const [visible, setVisible] = React.useState(false)
    const [addCatatan, setAddCatatan] = React.useState(false)
    const [listLokasi, setListLokasi] = React.useState([])
    const [lokasi, setLokasi] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [dataAntrian, setDataAntrian] = React.useState([])
    const [rawData, setRawData] = React.useState([])
    const [statusAntrian, setStatusAntrian] = React.useState("")
    const [skip, setSkip] = React.useState(false);
    const [tabSubfacility, setTabSubFacility] = React.useState([])
    const [idTab, setIDTab] = React.useState("")
    const [facilityIDTab, setFacilityIDTab] = React.useState("")
    const [facility_id, setFacilityID] = React.useState("")
    const [facility_queue_id, setFacilityQueueID] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [dataList, setDataList] = useState([])
    const prevCount = usePrevious(dataList);
    const [dataLama, setDataLama] = useState([])
    const [dataBaru, setDataBaru] = useState([])
    const [dataBadge, setDataBadge] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const wrapperRef = React.createRef()

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }

    useEffect(() => {
        getTabSubFacility()
        props.setShowNotif(false)
        setLoading(true)
        getData()

    }, [])

    // useEffect(() => {
    //     if (dataList.length != (prevCount !== undefined ? prevCount.length : -1)) {
    //         getTabSubFacility()
    //         props.setShowNotif(false)
    //         setLoading(true)
    //     }
    //     const interval = setInterval(() => {
    //         getData()
    //     }, 5000);
    //     return () => clearInterval(interval);
    // }, [dataBaru])


    const getData = () => {
        api.create().getSubFacilityByFacilityID(location.state.id).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.data.length > 0) {
                    let a = response.data.data.filter(elm => !dataLama.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                    if (a.length > 0) {
                        // console.log(response.data.data);
                        let tabSubfacility = []
                        let totalSkip = 0
                        if (response.data.data.length > 0) {
                            response.data.data.map((item, index) => {
                                if (item.status === 1) {
                                    tabSubfacility.push(item)
                                    totalSkip += item.total_skip_queue
                                }
                            })
                        }
                        if (tabSubfacility.length === 0) {
                            history.replace('/')
                        }
                        tabSubfacility.push({
                            name: 'List Antrian - Terlewat',
                            facility_id: location.state.id,
                            id: null,
                            total_queue: totalSkip
                        })
                        setDataBadge(tabSubfacility)
                    }
                } else {
                }
                setDataBaru(response.data.data)
                // setLoading(false)
            }
        })
    }

    const getTabSubFacility = () => {
        api.create().getSubFacilityByFacilityID(location.state.id).then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let tabSubfacility = []
                    let totalSkip = 0
                    if (response.data.data.length > 0) {
                        if (dataBadge.length === 0) {
                            setIDTab(response.data.data[0].id)
                            setFacilityIDTab(response.data.data[0].facility_id)
                        }
                        response.data.data.map((item, index) => {
                            if (item.status === 1) {
                                tabSubfacility.push(item)
                                totalSkip += item.total_skip_queue
                            }
                        })
                    }
                    tabSubfacility.push({
                        name: 'List Antrian - Terlewat',
                        facility_id: location.state.id,
                        id: null,
                        total_queue: totalSkip
                    })
                    // console.log(tabSubfacility);
                    setDataBadge(tabSubfacility)
                    setTabSubFacility(tabSubfacility)
                    setLoading(false)
                    setDataLama(response.data.data)
                    setDataList(response.data.data)
                    forceUpdate()
                } else {
                    setLoading(false)
                }
            }
        })
    }

    useEffect(() => {
        // console.log(props.location.state);
        if (props.location.state.dataNotif) {
            let idx = tabSubfacility.findIndex((val) => val.id === props.location.state.dataNotif.sub_facility_id)
            if (idx > -1) {
                setValue(idx)
                setLoading(true)
                setIDTab(props.location.state.dataNotif.sub_facility_id)
                setFacilityIDTab(props.location.state.dataNotif.facility_id)
                setTimeout(() => {
                    setLoading(false)
                }, 500)
                forceUpdate()
            }
        }
        // const interval = setInterval(() => {
        //     console.log(tabSubfacility);
        //     getTabSubFacility()
        // }, 3000);
        // return () => clearInterval(interval);
    }, [tabSubfacility, dataBadge])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div>
            {loading && (loadingComponent)}
            <Paper style={{ boxShadow: 'none' }} >
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="#2a9c6c"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                    style={{ outline: 'null' }}
                    classes={{ indicator: classes.tabsIndicator }}
                >
                    {/* <Tab label="List Antrian" style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                    <Tab label="List Antrian - Terlewat" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} /> */}
                    {tabSubfacility.length > 0 && tabSubfacility.map((item, index) => {
                        // console.log(dataBadge[index])
                        return (
                            <Tab id={item.id}
                                label={<Badge badgeContent={dataBadge[index].total_queue} color="primary">
                                    {item.name}
                                </Badge>}
                                style={{ color: value === index ? '#2a9c6c' : 'black' }}
                                onClick={() => {
                                    setLoading(true)
                                    setIDTab(item.id === null ? "" : item.id)
                                    setFacilityIDTab(item.facility_id)
                                    setSkip(item.name === 'List Antrian - Terlewat' ? true : false)
                                    setTimeout(() => {
                                        setLoading(false)
                                    }, 500)
                                }} />
                        )
                    })}
                </Tabs>
            </Paper>

            {!loading && (
                <TabSubFacility
                    idTab={idTab}
                    idFacility={facilityIDTab}
                    loket={true}
                    skip={skip}
                    refreshBadge={() => getData()}
                />
            )
            }
        </div>
    )
}